module.exports = __webpack_public_path__ + "static/miele-map-100329ade2227819680f63b9c15e8f45.jpg";